import ThreeColumnsColumn from '@/report/models/Charts/ThreeColumnsColumn';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
    props: {
        columns: { type: Array as PropType<Array<ThreeColumnsColumn>> },
        align: { type: String, default: 'center' },
    },
});
